import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { isMobile } from 'react-device-detect'
import { toast } from 'react-toastify'
import { Me } from 'service/user'
import { ReactComponent as CopyIcon } from 'svg/copy.svg'
import { ReactComponent as ExternalIcon } from 'svg/fi_external-link.svg'
import { UserType } from 'utils/common'
import { ReactComponent as HelpIcon } from 'svg/test.svg'
interface FastclickDashBoardProps {
  userInfo: Me
  blockWidth?: string
  blockPadding?: string
}

export const FastclickDashBoard = ({
  userInfo,
  blockWidth,
  blockPadding,
}: PropsWithChildren<FastclickDashBoardProps>) => {
  const moveToUrl = (url: string) => {
    if (url) {
      window.open(url)
    }
  }

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success('copy 완료', {
        position: 'bottom-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })
    } catch (e) {}
  }
  return (
    <div
      className={classNames(
        'flex flex-col mt-2 bg-white rounded-[10px]  py-4 ',
        { 'px-5': !blockPadding, [`${blockPadding}`]: blockPadding }
      )}
    >
      <div
        className={classNames('flex  gap-[14px] ', {
          'flex-row items-center justify-between': !isMobile,
          'flex-col ': isMobile,
        })}
      >
        <div className="flex flex-col gap-1 ">
          <div>
            <p className="flex gap-2 items-center">
              <span>
                <img src="assets/img/logo/fastclick.png" alt="fastclick" />
              </span>
              <span className="text-[#FF4B4B] font-[900] ">FASTCLICK</span>
              <span className="text-[#5E6068] font-[900] text-[14px] ">
                for 상품 숏폼
              </span>
              {!isMobile && (
                <span className="text-[#8F929B] text-[14px] ">
                  상품 숏폼을 만들면, 자동으로 링크블록이 생성돼요!
                </span>
              )}
            </p>
            <p className="font-bold mt-2">
              나의 패스트클릭 페이지 주소{' '}
              <a
                href={userInfo?.fastClickLink?.fastClickLink}
                target="_blank"
                rel="noreferrer"
                className="text-href text-[14px]"
              >
                {userInfo?.fastClickLink?.fastClickLink}
              </a>
            </p>
          </div>
        </div>
        <div
          className={classNames(' font-bold text-[12px] text-[#5E6068]', {
            'flex  gap-1 flex-col w-[120px]': !isMobile,
            'grid grid-cols-2 gap-x-1': isMobile,
          })}
        >
          <button
            className="bg-[#EEF1F7] rounded-[10px]  h-[32px] flex justify-center items-center gap-1"
            onClick={() => {
              moveToUrl('https://blog.fastseller.shop/fastclick_guide/')
            }}
          >
            <HelpIcon className="text-[#8F929B]" />
            링크로 수익내기
          </button>
          <button
            className="bg-[#EEF1F7] rounded-[10px] h-[32px] flex justify-center items-center gap-1"
            onClick={() => {
              handleCopyClipBoard(userInfo?.fastClickLink?.fastClickLink)
            }}
          >
            <CopyIcon className="text-[#8F929B]" /> 주소 복사{' '}
          </button>
        </div>
      </div>
      <div
        className="flex gap-3  cursor-pointer w-full mt-1"
        onClick={() => {
          moveToUrl(userInfo?.fastClickLink?.fastClickLink)
        }}
      >
        <p
          className={classNames(
            ' flex justify-between items-center px-4 py-3 bg-gradient-to-r from-[#FF1E5E] to-[#FF8A00] rounded-[10px]',
            {
              'w-[562px]': !isMobile && !blockWidth,
              'w-full': isMobile,
              [`${blockWidth}`]: blockWidth,
            }
          )}
        >
          <span className="font-bold text-[14px] text-white ">
            나의 링크 블록 확인하러 가기
          </span>
          <span className="font-bold text-[16px] text-white">
            {userInfo?.userType !== UserType.USER
              ? userInfo?.fastClickLink?.productCount.toLocaleString() ?? 0
              : 0}
            개 {`>`}
          </span>
        </p>
      </div>
    </div>
  )
}
